import { useEventListener } from '@vueuse/core';
import { nextTick } from 'vue';

export default function useUcEvent(
  name: UcEventName,
  fn: (e: CustomEvent) => any
) {
  return useEventListener(document.body, name, (e: CustomEvent) => {
    nextTick(() => fn(e));
  });
}

export function dispatchUcEvent(name: UcEventName, detail?: any) {
  document.body.dispatchEvent(new CustomEvent(name, { detail }));
}
